<template>
  <el-container class="f-h">
    <el-header class="toolbar" style="height: 2.5rem">
      <el-row type="flex" justify="space-between" class="sub-title">
        <div>
          回访：
          <el-button type="primary" size="small" icon="el-icon-document-add" @click="create">新建计划</el-button>
        </div>
        <div>
          <el-date-picker
            size="small"
            v-model="condition.planDate"
            type="date"
            placeholder="计划回访日期"
            value-format="yyyy-MM-dd"
            @change="queryEntities"
          />

          <el-input size="small" class="left-pad condition-wide" type="text" v-on:keyup.enter.native="queryEntities" clearable
            placeholder="患者姓名" v-model="condition.patientName">
            <el-button slot="append" icon="el-icon-search" @click="queryEntities" :disabled="meta.loading">查询
            </el-button>
          </el-input>

          <el-input size="small" class="left-pad condition-wide" type="text" v-on:keyup.enter.native="queryEntities" clearable
            placeholder="医生姓名" v-model="condition.doctorName">
            <el-button slot="append" icon="el-icon-search" @click="queryEntities" :disabled="meta.loading">查询
            </el-button>
          </el-input>
        </div>
      </el-row>
    </el-header>
    <el-main style="padding: 0">
      <el-table @filter-change="filterChanged" @sort-change="handleSortChange" v-loading="meta.loading"
        :data="entities.items" stripe class="main-table">
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.finishEdit"
              type="primary"
              plain
              size="mini"
              v-loading="scope.row.loading"
              circle
              icon="el-icon-check"
              @click="save(scope.row, true)"
              title="完成回访">
            </el-button>
            <el-button
              v-else
              type="primary"
              plain
              size="mini"
              circle
              icon="el-icon-s-flag"
              :disabled="scope.row.edit"
              @click="finish(scope.row)"
              title="回访"
            >
            </el-button>

            <div style="display: inline-block; margin-left: 8px">
              <el-button
                v-if="scope.row.edit"
                type="primary"
                plain
                size="mini"
                v-loading="scope.row.loading"
                circle
                icon="el-icon-check"
                @click="save(scope.row, false)"
                title="保存编辑">
              </el-button>
              <el-button
                v-else-if="!scope.row.ifExec"
                type="primary"
                plain
                size="mini"
                circle
                icon="el-icon-edit"
                @click="edit(scope.row)"
                :disabled="scope.row.finishEdit"
                title="编辑">
              </el-button>
            </div>

            <div v-if="scope.row.edit || scope.row.finishEdit" style="display: inline-block; margin-left: 8px">
              <el-button
                v-if="scope.row.edit"
                type="danger"
                plain
                size="mini"
                circle
                icon="el-icon-close"
                title="取消编辑"
                @click="$set(scope.row, 'edit', false)">
              </el-button>
              <el-button
                v-if="scope.row.finishEdit"
                type="danger"
                plain
                size="mini"
                circle
                icon="el-icon-close"
                title="取消回访"
                @click="$set(scope.row, 'finishEdit', false)">
              </el-button>
            </div>

            <el-popconfirm
              v-if="!scope.row.ifExec && !scope.row.edit && !scope.row.finishEdit"
              class="left-pad"
              title="确定要删除吗?"
              icon-color="red"
              @confirm="del(scope.row)">
              <el-button slot="reference" title="删除" type="danger" plain size="mini" circle icon="el-icon-delete">
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>

        <el-table-column sortable="custom" label="状态" align="center" width="90" prop="ifExec">
          <template slot-scope="{row}">
            <el-tag v-if="row.ifExec" type="success" effect="plain" size="mini">已回访</el-tag>
            <el-tag v-else type="warning" effect="plain" size="mini">未回访</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="患者姓名" align="center" width="80" prop="patientName">
        </el-table-column>
        <el-table-column label="患者电话" align="center" width="110" prop="phone">
        </el-table-column>

        <el-table-column label="患者性别" align="center" width="80" prop="patientGender">
          <template slot-scope="scope">
            {{ scope.row.patientGender | dictText("Gender") }}
          </template>
        </el-table-column>

        <el-table-column label="患者年龄" align="center" width="80" prop="patientAge">
        </el-table-column>

        <el-table-column sortable="custom" label="医生姓名" align="center" width="130" prop="doctorName">
        </el-table-column>

        <el-table-column label="回访内容" align="center" prop="content" show-overflow-tooltip>
          <template slot-scope="{row}">
            <el-input
              v-if="row.edit"
              v-model="row.content"
              size="small"
              placeholder="请输入回访内容"
              :maxlength="55">
            </el-input>
            <span v-else> {{ row.content }}</span>
          </template>
        </el-table-column>

        <el-table-column label="患者反馈" align="center" prop="feeback">
          <template slot-scope="{row}">
            <el-input
              v-if="row.finishEdit"
              v-model="row.feeback"
              size="small"
              placeholder="请输入患者反馈"
              :maxlength="80">
            </el-input>
            <span v-else>{{ row.feeback }}</span>
          </template>
        </el-table-column>

        <el-table-column label="计划回访日期" align="center" width="150" prop="planDate">
          <template slot-scope="{row}">
            <el-date-picker
              v-if="row.edit"
              size="small"
              style="width: 100%"
              v-model="row.planDate"
              type="date"
              placeholder="年/月/日"
              value-format="yyyy-MM-dd"
              :clearable="false"
            />
            <span v-else>{{ row.planDate }}</span>
          </template>
        </el-table-column>

        <el-table-column label="实际回访日期" align="center" width="205" prop="execDate">
          <template slot-scope="{row}">
            <el-date-picker
              v-if="row.finishEdit"
              size="small"
              style="width: 100%"
              v-model="row.execDate"
              type="datetime"
              placeholder="选择回访日期时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :clearable="false"
            />
            <span v-else>{{ row.execDate }}</span>
          </template>
        </el-table-column>

        <el-table-column label="回访人" align="center" width="100" prop="executorName">
          <!--<template slot-scope="{row}">
            <el-input
              v-if="row.finishEdit"
              v-model="row.executorName"
              size="small"
              placeholder="请输入"
              :maxlength="80" />
            <span v-else>{{ row.executorName }}</span>
          </template>-->
        </el-table-column>
        <!--<el-table-column label="备注" align="center" min-width="80" prop="memo" show-overflow-tooltip></el-table-column>-->
      </el-table>
    </el-main>
    <editor v-model="entity" :visible.sync="meta.showEditor" @queryChannels="queryEntities"></editor>
    <pagination :entities="entities" @queryEntities="queryEntities" :condition="condition" />
  </el-container>
</template>

<script>
import api from "./api";
import { mapGetters } from "vuex";
export default {
  components: {
    editor: () => import("./editor"),
    pagination: () => import("@/components/_com/pagination"),
  },
  data() {
    return {
      meta: {
        showEditor: false,
        loading: false,
      },
      condition: {
        sort: "id",
        asc: false,
        planDate: '',
        pageIndexOnView: 1,
        pageSize: 20,
      },
      entities: {},
      entity: {},
    };
  },
  computed: {
    ...mapGetters(["permission"]),
  },
  created() {
    this.queryEntities();
  },
  methods: {
    handleSortChange({ prop, order }) {
      this.condition.asc = order === "ascending";
      this.condition.sort = prop;
      this.queryEntities();
    },
    filterChanged(options) {
      Object.assign(this.condition, options);
      this.queryEntities();
    },
    create() {
      this.entity = { id: null, rota: [] };
      this.$nextTick(() => {
        this.meta.showEditor = true;
      });
    },
    finish(row) {
      this.$set(row, 'finishEdit', true);
      this.$set(row, 'edit', false);
    },
    edit(row) {
      this.$set(row, 'edit', true);
      this.$set(row, 'finishEdit', false);
    },
    del(row) {
      api.delReturnVisit(row.id).then(
        (res) => {
          this.$message.success("删除成功");
          this.queryEntities();
        },
        (msg) => {
          this.$message({
            type: "error",
            message: msg,
          });
        }
      );
    },
    save(row, isFinish) {
      if (isFinish) {
        if (!row.feeback) {
          this.$message.warning('请填写患者反馈内容');
          return;
        }
        if (!row.execDate) {
          this.$message.warning('请选择实际回访日期');
          return;
        }
      }
      this.$set(row, "loading", true);
      const payload = { ...row };
      payload.ifExec = isFinish;
      if (isFinish) {
        const { user } = this.$store.state;
        payload.executorId = user.id;
        payload.executorName = user.name;
      }
      api
        .saveReturnVisit(payload)
        .then((res) => {
          this.$message.success("保存成功");
          this.$set(row, 'ifExec', isFinish);
          this.queryEntities();
        })
        .catch((err) => {
          this.$message.error(err || err.message);
        })
        .finally(() => {
          this.$set(row, "loading", false);
        });
    },
    queryEntities() {
      this.meta.loading = true;
      api
        .getReturnVisit(this.condition)
        .then((res) => {
          this.$set(this, "entities", res);
        })
        .catch((reason) => {
          console.log("Getting registration number type failure:", reason);
        })
        .finally(() => {
          this.meta.loading = false;
        });
    },
  },
};
</script>

<style scoped>
</style>
